import React, { useState } from 'react';
import { Tag } from 'lucide-react';
import ModalShell from './ModalShell';

const CategoryModal = ({ isOpen = true, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({ name: '' });

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) return;
    onSubmit({ name: formData.name });
  };

  if (!isOpen) return null;

  return (
    <ModalShell
      title="Add New Category"
      subtitle="Create a product category"
      icon={Tag}
      onClose={onClose}
      footer={(
        <>
          <button type="button" onClick={handleSubmit} className="ui-btn-primary flex-1">
            Add Category
          </button>
          <button type="button" onClick={onClose} className="ui-btn-secondary flex-1">
            Cancel
          </button>
        </>
      )}
    >
      <form onSubmit={handleSubmit}>
        <label className="ui-label">Category Name</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => handleInputChange('name', e.target.value)}
          className="ui-input"
          placeholder="Enter category name"
        />
      </form>
    </ModalShell>
  );
};

export default CategoryModal;
